import axios from 'axios';
import { serverUrl } from '../Constants';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';

export type UseApiProps = {
    loading: boolean
    errors: any[]
}

export type ConfigUseApi = {
    body: any
    requiredToken: boolean
    onRequest: boolean
}

export default function useApi<T>(type: 'post' | 'get', action: string, config = {
    requiredToken: true,
    onRequest: false
}) {
    const { requiredToken, onRequest } = config

    const [data, setData] = useState<T | null>(null)
    const [loading, setLoading] = useState(!onRequest)
    const [errors, setErrors] = useState<any[]>([])
    const { token } = useSelector((state: any) => state)

    const [lastExternalBody, setLastExternalBody] = useState()

    
    let extra = {}
    if (requiredToken) {
        extra = {
            'Authorization' : `Bearer ${token}`
        }
    }

    // const headers = {
    //     'Content-Type': 'application/json',
    //     ...extra
    // }

    async function start(externalBody: any = undefined) {
        setLastExternalBody(externalBody)
        const isFormData = externalBody instanceof FormData;

        const headers = isFormData ? {...extra} : {
            'Content-Type': 'application/json',
            ...extra
        }

        setData(null)
        setErrors([])
        setLoading(true)
        setTimeout(async () => {
            try {
                let response
                if (type === 'post') {
                    response = await axios.post(`${serverUrl}${action}`, externalBody, { headers })
                } else {
                    const qS = new URLSearchParams(externalBody).toString();
                    response = await axios.get(`${serverUrl}${action}${externalBody ? `?${qS}` : ''}`, { headers })
                }
                if (response.data.status === 'success') {
                    setData(response.data)
                } else {
                    setErrors([{
                        status: response.data.status,
                        statusMessage: response.data.msg,
                        keycode: response.data.error
                    }])
                }
                // @ts-ignore
            } catch (err: any){
                const localErrors = []
                if (err.message === 'Network Error' || err.response === undefined){
                    localErrors.push({
                        status: 0,
                        statusMessage: 'Network Error'
                    })
                } else {
                    localErrors.push({
                        status: err.response.status,
                        statusMessage: err?.response?.data?.message || err.response.statusText,
                        keycode: '0'
                    })
                }
                setErrors(localErrors)
            } finally {
                setLoading(false)
            }
        }, 300)
    }

    async function refetchLast() {
        start(lastExternalBody)
    }

    useEffect(() => {
        if (!onRequest) {
            start()        
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return {
        data,
        loading,
        errors,
        refetch: start,
        fetch: start,
        refetchLast,
        setLoading
    }
}